import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useConfigStore } from '@/stores/configStore'
import { questionSchema, Question, Dimension } from '@/types/config'

export const useQuestionStore = defineStore('question', () => {
  const configStore = useConfigStore()
  const { config, isLoading, isError } = storeToRefs(configStore)

  const questions = computed<Question[]>(() => {
    return config.value?.rightAsk?.questions || []
  })

  const getById = (id: string): Question | undefined =>
    questions.value.find((question: Question) => question.id === id)
  const getBySegmentGroupId = (id: string): Question | undefined =>
    questions.value.find((question: Question) => question.dimensionId === id)

  const destroy = (question: Question) => {
    const foundIndex = config.value?.rightAsk?.questions.findIndex(
      (q) => q.id === question.id
    )
    if (foundIndex === -1) return // this should really never happen

    config.value?.rightAsk?.questions?.splice(foundIndex, 1)
  }

  const createInputQuestion = (questionData: any) => {
    // Create a new question without a dimension/segment group
    const newQuestion = {
      id: questionData.id,
      text: questionData.text,
      description: questionData.description,
      displayType: questionData.displayType || 'input',
      inputType: questionData.inputType,
      inputSettings: questionData.inputSettings || {},
      syncTo: questionData.syncTo,
      syncToField: questionData.syncToField,
      dimensionId: null, // Input questions don't have a dimension
      options: [], // Input questions don't have options
      otherOptions: {
        enabled: false
      },
      displayOptions: {}
    }

    // Add to config
    if (!config.value?.rightAsk) {
      config.value.rightAsk = { questions: [] }
    }
    config.value.rightAsk.questions.push(newQuestion)

    return newQuestion
  }

  const updateInputQuestion = (questionData: any) => {
    const question = getById(questionData.id)
    if (!question) return

    // Update the question properties
    question.text = questionData.text
    question.description = questionData.description
    question.inputType = questionData.inputType
    question.inputSettings = questionData.inputSettings || {}
    question.syncTo = questionData.syncTo
    question.syncToField = questionData.syncToField

    return question
  }

  return {
    questions,
    getById,
    getBySegmentGroupId,
    destroy,
    createInputQuestion,
    updateInputQuestion,
    isLoading,
    isError
  }
})
